import { render } from "./MedicamentoSelect.vue?vue&type=template&id=2e2f043b&scoped=true"
import script from "./MedicamentoSelect.vue?vue&type=script&lang=js"
export * from "./MedicamentoSelect.vue?vue&type=script&lang=js"

import "./MedicamentoSelect.vue?vue&type=style&index=0&id=2e2f043b&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2f043b"]])

export default __exports__